<template>
  <div>
    <el-main v-loading="loading">
      <!-- 搜索栏 -->
      <div class="search-box">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="内容">
            <el-input v-model="searchForm.content" size="small" placeholder="请输入内容关键词"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="search">搜索</el-button>
            <el-button size="small" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table :data="list" border style="width: 100%">
        <el-table-column prop="msgid" label="日志id" width="380" align="center"></el-table-column>
        <!-- <el-table-column prop="sender" label="用户" min-width="80" align="center"></el-table-column> -->
        <el-table-column prop="content" label="文本内容" min-width="250" align="center" show-overflow-tooltip></el-table-column>
       
        <el-table-column label="内容是否合规" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_compliance === 0 ? 'warning' : (scope.row.is_compliance === 1 ? 'success' : 'danger')">
              {{ scope.row.is_compliance === 0 ? '待审核' : (scope.row.is_compliance === 1 ? '合规' : '违规') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="内容创建时间" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button 
              type="text" 
              @click="showTextDetail(scope.row)"
            >查看</el-button>
            <el-button 
              v-if="scope.row.status === 0 || scope.row.status === 1"
              type="text" 
              @click="showAuditDialog(scope.row)"
            >审核</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <!-- 文本详情弹窗 -->
      <el-dialog
        title="文本详情"
        :visible.sync="textDetailDialogVisible"
        width="600px"
      >
        <div v-if="currentText" class="text-detail">
          <p><strong>内容：</strong></p>
          <p class="text-content">{{ currentText.content }}</p>
          <p><strong>发送时间：</strong> {{ currentText.create_time | formatDate }}</p>
          <p><strong>用户：</strong> {{ currentText.nickname }}</p>
        </div>
      </el-dialog>

      <!-- 审核弹窗 -->
      <el-dialog
        title="文本审核"
        :visible.sync="auditDialogVisible"
        width="500px"
      >
        <el-form :model="auditForm" ref="auditForm" :rules="auditRules" label-width="100px">
          <el-form-item label="审核结果" prop="status">
            <el-radio-group v-model="auditForm.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="拒绝原因" prop="reject_reason" v-if="auditForm.status === 2">
            <el-input 
              type="textarea" 
              v-model="auditForm.reject_reason" 
              placeholder="请输入拒绝原因"
              :rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="auditDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAudit">确定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'AiReviewList',
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        content: '',
      },
      textDetailDialogVisible: false,
      currentText: null,
      auditDialogVisible: false,
      auditForm: {
        id: null,
        status: 1,
        reject_reason: ''
      },
      auditRules: {
        status: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ],
        reject_reason: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      }
    };
  },
  filters: {
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true   
      try {
        const res = await this.$axios.post('/AiModel/Chat/messageList', {
            page: this.page,
            rows: this.pageSize,
            ...this.searchForm
        })
        if (res.code === 0) {
          this.list = res.result.list
          this.total = res.result.total_number
        }
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },

    // 搜索
    search() {
      this.page = 1
      this.getList()
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        content: '',
        status: ''
      }
      this.search()
    },

    // 查看文本详情
    showTextDetail(row) {
      this.currentText = row
      this.textDetailDialogVisible = true
    },

    // 显示审核弹窗
    showAuditDialog(row) {
      this.auditForm = {
        id: row.id,
        status: row.status === 0 ? 1 : row.status,
        reject_reason: ''
      }
      this.auditDialogVisible = true
    },

    // 提交审核
    submitAudit() {
      this.$refs.auditForm.validate(async (valid) => {
        if (valid) {
          try {
            await this.$axios.post('/Admin/AiModel/Chat/editStatus', this.auditForm)
            this.$message.success('审核操作成功')
            this.auditDialogVisible = false
            this.getList()
          } catch (error) {
            console.error(error)
          }
        }
      })
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    }
  }
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
  padding: 20px;
}

.search-box {
  margin-bottom: 20px;
}

.pagination-box {
  margin-top: 20px;
  text-align: right;
}

.text-detail {
  padding: 10px;
  
  .text-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 5px;
    margin: 10px 0;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
  
  